/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Dju_HelpInputs */



/**
* | output |
* | --- |
* | "Adds to each series its version brought to the normal climate with the degree days of the building's weather station, to compare without the effect of the we..." |
*
* @param {Consumption_Dju_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_dju_help = /** @type {((inputs?: Consumption_Dju_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Dju_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Adds to each series its version brought to the normal climate with the degree days of the building's weather station, to compare without the effect of the weather. Shown in the monthly view.")
	return /** @type {LocalizedString} */ ("Ajoute à chaque série sa version ramenée au climat normal avec les degrés-jours unifiés (DJU) de la station météo du bâtiment, pour comparer sans l'effet de la météo. S'affiche en vue mensuelle.")
});